import { render, staticRenderFns } from "./ContractServiceEditor.yaml?vue&type=template&id=01508459&component"
import script from "./ContractServiceEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ContractServiceEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports